import { Handshake } from 'lucide-react'
import { NetworkingSpaceFields } from '@/components/features/networking/NetworkingSpaceFields'
import {
  defaultNetworkingConfig, networkingConfigApiErrors, resolveConfig, validateNetworkingConfig
} from '@/components/features/networking/networkingConfig'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const NetworkingPage = lazyPage(() => import('@/pages/Networking'), 'NetworkingPage')

/**
 * F-176 Networking: the space is the program (no "one or many"). The model
 * (PROPOSTA-NETWORKING section 2.5) and its options are a step of their own in
 * the wizard and the same component in the space settings. A person's
 * networking profile is the member page (F-177) with the space's section.
 */
export const networkingModule: ModuleDefinition = {
  key: 'networking',
  icon: Handshake,
  iconName: 'handshake',
  namespaces: ['networking', 'bookings', 'scheduling'],
  ready: true,
  ListPage: NetworkingPage,
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'networking:config.stepLabel',
    stepHintKey: 'networking:config.stepHint',
    defaultConfig: () => defaultNetworkingConfig(),
    validate: (config, t) => validateNetworkingConfig(config, t),
    errorsFromApi: (err) => networkingConfigApiErrors(err),
    Fields: NetworkingSpaceFields,
    persist: {
      type: 'moduleConfig',
      /* This screen owns every key of `networking`; whatever else the space stored goes back untouched. */
      toModuleConfig: (config, stored) => ({ ...(stored || {}), networking: config }),
      fromSpace: (space) => resolveConfig(space.moduleConfig?.networking)
    }
  },
  workflow: { trigger: { block: 'networking', families: ['networking'] } }
}
